import { useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import SweetAlert2 from "react-sweetalert2";
import "./memberList.css";
import * as actions from "../redux/MemberAction";
import { useParams } from "react-router-dom";
import { Switch } from "antd";
import { EditMemberDialog } from "./EditMemberDialog";
import { Modal } from "../../common/Modal1";

export const MemberList = ({
  selMemberId,
  isMemberDetailsVisible,
  onClose,
}) => {
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const [oldNickname, setOldNickname] = useState(null);
  const [isEditModalVisible, setEditModalVisible] = useState(false);
  const memberState = useSelector(({ member }) => member, shallowEqual);

  useEffect(() => {
    const queryParams = {
      action: "memberdetail",
      memberid: selMemberId,
    };
    dispatch(actions.callMemberList(queryParams));
  }, [selMemberId]);
  const handleSwitchChange = (checked, member) => {
    const updateQueryParams = {
      action: "updatememberstatus",
      memberid: member,
    };
    dispatch(actions.updateMemberStatus(updateQueryParams))
      .then(() => {
        const queryParams = {
          action: "memberdetail",
          memberid: selMemberId,
        };
        dispatch(actions.callMemberList(queryParams));
      })
      .catch((error) => {
        console.error("Error updating Member status:", error);
      });
  };
  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="agentDetailsModal"
        title={intl.formatMessage({ id: "agentDetails" })}
        dismissBtnRef={dismissBtnRef}
        isVisible={isMemberDetailsVisible}
        onClose={onClose}
      >
        <SweetAlert2
          customClass="custom-swal"
          onResolve={() => {
            setSwalProps({});
          }}
          {...swalProps}
        />
        <EditMemberDialog
          setSwalProps={setSwalProps}
          memberId={selMemberId}
          oldNickname={oldNickname}
          isVisible={isEditModalVisible}
          onClose={() => setEditModalVisible(false)}
        />

        <div>
          <div
            className="d-flex"
            style={{
              overflowX: "auto",
              margin: "10px auto",
              justifyContent: "center",
              justifyItems: "center",
            }}
          >
            <div className="member-container">
              <div className="member-header">
                <div className="member-cell">
                  {intl.formatMessage({ id: "username" })}
                </div>
                <div className="member-cell">
                  {intl.formatMessage({ id: "nickname" })}
                </div>
                <div className="member-cell">
                  {intl.formatMessage({ id: "balance" })}
                </div>
                <div className="member-cell">
                  {intl.formatMessage({ id: "ipaddress" })}
                </div>
                <div className="member-cell">
                  {intl.formatMessage({ id: "inviteby" })}
                </div>
                <div className="member-cell">
                  {intl.formatMessage({ id: "status" })}
                </div>
                <div className="member-cell">
                  {intl.formatMessage({ id: "regdate" })}
                </div>
              </div>
              <div className="member-middle">
                <div className="member-cell">:</div>
                <div className="member-cell">:</div>
                <div className="member-cell">:</div>
                <div className="member-cell">:</div>
                <div className="member-cell">:</div>
                <div className="member-cell">:</div>
                <div className="member-cell">:</div>
              </div>
              <div className="member-body">
                {memberState && memberState.memberLists ? (
                  <div>
                    <div className="member-cell">
                      {memberState.memberLists.username}
                    </div>
                    <div className="member-cell">
                      {memberState.memberLists.nickname}
                    </div>
                    <div className="member-cell">
                      {memberState.memberLists.balance}
                    </div>
                    <div className="member-cell">
                      {memberState.memberLists.ipaddress === ""
                        ? "-"
                        : memberState.memberLists.ipaddress}
                    </div>
                    <div className="member-cell">
                      {memberState.memberLists.inviteby}
                    </div>
                    <div className="member-cell">
                      <Switch
                        checked={memberState.memberLists.status === "active"}
                        onChange={(checked) =>
                          handleSwitchChange(
                            checked,
                            memberState.memberLists.memberid
                          )
                        }
                      />
                    </div>
                    <div className="member-cell">
                      {memberState.memberLists.regdate}
                    </div>
                  </div>
                ) : (
                  <Skeleton height="600px" className="w-100" />
                )}
              </div>
            </div>
          </div>
          <div className="editButton p-3">
            <button
              className="btn btn-primary px-3"
              onClick={() => {
                setOldNickname(memberState.memberLists.nickname);
                setEditModalVisible(true);
              }}
            >
              {intl.formatMessage({ id: "edit" })}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

// import { useState } from "react";
// import { useIntl } from "react-intl";
// import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import { useEffect } from "react";
// import Skeleton from "react-loading-skeleton";
// import SweetAlert2 from "react-sweetalert2";
// import "./memberList.css";

// export const MemberList = () => {
//   const intl = useIntl();
//   const [swalProps, setSwalProps] = useState({});
//   const dispatch = useDispatch();
//   const settingState = useSelector(({ setting }) => setting, shallowEqual);

//   useEffect(() => {
//     // dispatch(actions.getWithdrawList({ }));
//   }, []);

//   //   const cancelWithdrawRequest = (itemid) => {
//   //     setSwalProps({
//   //       show: true,
//   //       icon: "info",
//   //       title: intl.formatMessage({ id: "alert" }),
//   //       text: intl.formatMessage({
//   //         id: "confirmationCancelWithdraw",
//   //       }),
//   //       showCancelButton: true,
//   //       showConfirmButton: true,
//   //       confirmButtonText: intl.formatMessage({ id: "confirm" }),
//   //       denyButtonText: intl.formatMessage({ id: "cancel" }),
//   //       onResolve: () => {
//   //         setSwalProps({});

//   //         dispatch(actions.cancelWithdrawRequest({ selitemid: itemid })).then(
//   //           (resp) => {
//   //             resp = resp.data;

//   //             if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
//   //               dispatch(actions.getWithdrawList({ days: dayType }));
//   //               dispatch(masterActions.getWalletInfo());

//   //               setSwalProps({
//   //                 show: true,
//   //                 icon: "success",
//   //                 title: intl.formatMessage({ id: "success" }),
//   //                 text: intl.formatMessage({
//   //                   id: "withdrawRequestCancelSuccessfully",
//   //                 }),
//   //               });
//   //             } else {
//   //               setSwalProps({
//   //                 show: true,
//   //                 icon: "error",
//   //                 title: intl.formatMessage({ id: "error" }),
//   //                 text: resp.message,
//   //               });
//   //             }
//   //           }
//   //         );
//   //       },
//   //     });
//   //   };

//   return (
//     <div style={{ width: "95%", margin: "5px auto" }}>
//       <SweetAlert2
//         customClass="custom-swal"
//         onResolve={() => {
//           setSwalProps({});
//         }}
//         {...swalProps}
//       />
//       <div
//         className="d-flex"
//         style={{
//           overflowX: "auto",
//           margin: "10px auto",
//         }}
//       >
//         <div className="member-div">
//           <div className="d-flex member-div2">
//             <div className="d-flex">
//               <input
//                 type="text"
//                 className="form-control me-2"
//                 placeholder={intl.formatMessage({ id: "username" })}
//               />
//               <select className="form-select">
//                 <option value="">MYR</option>
//                 <option value="option1">IDR</option>
//               </select>
//             </div>
//             <div>
//               <button
//                 className="btn btn-primary"
//                 // onClick={onSearch}
//               >
//                 {intl.formatMessage({ id: "search" })}
//               </button>
//             </div>
//           </div>

//           <table className="member-table">
//             <thead>
//               <tr className="member-tr">
//                 <th>{intl.formatMessage({ id: "no" })}</th>
//                 <th>{intl.formatMessage({ id: "username" })}</th>
//                 <th>{intl.formatMessage({ id: "nickname" })}</th>
//                 <th>{intl.formatMessage({ id: "inviteBy" })}</th>
//                 <th>{intl.formatMessage({ id: "status" })}</th>
//                 <th>{intl.formatMessage({ id: "action" })}</th>
//               </tr>
//             </thead>
//             <tbody>
//               {-1 > 0 ? (
//                 <div>
//                   {settingState.transactionReport.memberReports.map(
//                     (report, index) => (
//                       <tr key={index}>
//                         <td>{row.username}</td>
//                         <td>{row.nickname}</td>
//                         <td>{row.status}</td>
//                         <td>
//                           <button onClick={() => handleAction(index)}>
//                             Delete
//                           </button>
//                         </td>
//                       </tr>
//                     )
//                   )}
//                 </div>
//               ) : (
//                 <td colspan="6">
//                   <div className="d-flex py-2 align-items-center justify-content-center noRecorddiv">
//                     <div className="d-flex align-items-center justify-content-center flex-column">
//                       <i className="bi bi-search fs-1 mb-3" />
//                       <div className="text-font2">
//                         {intl.formatMessage({ id: "noRecordFound" })}
//                       </div>
//                     </div>
//                   </div>
//                 </td>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };
